
























































































































import { faTrashAlt } from '@fortawesome/free-regular-svg-icons'
import {
  defineComponent,
  computed,
  toRefs,
  useRoute
} from '@nuxtjs/composition-api'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import { ciTradesLikes } from '~/icons/source/regular/trades-likes'
import { useNamespacedStore } from '~/compositions/store'
import { TRADES_NS, TradesState } from '~/store/modules/shared/trades/state'

export default defineComponent({
  components: { CAvatar },
  props: {
    rows: { type: Array, required: true },
    loading: { type: Boolean, default: false },
    buttonLabel: { type: String, default: '' },
    withoutButtons: { type: Boolean, default: false },
    removeOnlyButton: { type: Boolean, default: false },
    removeButtonTitle: { type: String, default: '' },
    likeButtonTitle: { type: String, default: '' },
    mine: { type: Boolean, default: false },
    classifiedId: { type: String, required: false, default: '' },
    currentPage: { type: Number, required: false, default: undefined },
    threadId: { type: String, required: false, default: undefined },
    mobile: { type: Boolean, default: false }
  },
  setup(props) {
    const { classifiedId, currentPage, threadId, withoutButtons } = toRefs(
      props
    )
    const route = useRoute()
    const icons = computed(() => ({
      remove: faTrashAlt,
      like: ciTradesLikes
    }))

    const { dispatch } = useNamespacedStore<TradesState>(TRADES_NS)

    const rowThreadRoute = (row: any) => {
      if (row?.message?.threadId) {
        return {
          name: '__trades_messages',
          params: {
            thread: row.message.threadId.toString(),
            cid: classifiedId.value
          },
          query: {
            from: 'matches',
            pg: currentPage.value.toString()
          }
        }
      } else {
      }
      if (!row.classified.isDeleted) {
        // default to the details link

        const query = { ...route.value.query }
        return {
          name: '__trades_swipe',
          query,
          hash: `#${row.classified.id}`
        }
      }
      return null
    }

    const onRowClick = (row: any) => {
      if (!row?.message?.threadId && rowThreadRoute(row)) {
        // we are probably at likes tab
        dispatch('setDetailsClassifiedId', row.classified.id)
        dispatch('changeNavbarVisibility', false)
        if (withoutButtons.value) {
          // we are in liked sub-tab
          dispatch('changeActionsVisibility', false)
        }
      }
    }

    const rowIsActive = (row: any) => {
      if (threadId?.value && row?.message?.threadId) {
        return row?.message?.threadId.toString() === threadId?.value.toString()
      }

      if (route.value.name === '__trades_swipe') {
        return route.value.hash === `#${row.classified.id}`
      }
      return false
    }

    return { icons, rowThreadRoute, rowIsActive, onRowClick }
  }
})
